module.exports = __webpack_public_path__ + "static/media/viure-als-pirineus-1.d08a51e0.png";